import { render } from "./UnlinkPrescriber.vue?vue&type=template&id=112c6b19"
import script from "./UnlinkPrescriber.vue?vue&type=script&lang=js"
export * from "./UnlinkPrescriber.vue?vue&type=script&lang=js"

import "./UnlinkPrescriber.vue?vue&type=style&index=0&id=112c6b19&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__